import React, { useEffect, useState } from 'react';
import Clock from 'react-clock';
import moment from 'moment';
import 'react-clock/dist/Clock.css';

const DashboardClock = () => {
  const [currentTime, setCurrentTime] = useState(moment().format('hh:mm A'));
  useEffect(() => {
    const interval = setInterval(() => setCurrentTime(new Date()), 1000);
    return () => clearInterval(interval);
  }, []);

  return <Clock value={currentTime} size={130} />;
};

export default DashboardClock;
